<template>
  <div id="app" class="noselect">
    <browser-check></browser-check>
    <Notifications/>
    <div class="backgroundimg-fixed"></div>
    <custom-header></custom-header>
    <transition
        name="fade"
        mode="out-in">
      <div class="loader" v-if="loading">
        <h1>{{ translate('application_loading') }}...</h1>
      </div>
      <router-view v-else/>
    </transition>
    <custom-footer></custom-footer>
  </div>
</template>

<script>
import Notifications from "./components/notifications/Notifications";
import BrowserCheck from "./components/notifications/BrowserCheck";

export default {
  name: 'app',
  components: {BrowserCheck, Notifications},
  computed: {
    getActiveStep() {
      return this.$store.state.activeConfigurationStep;
    },
    activeLanguageChanged() {
      return this.$store.state.activeLang.id;
    },
  },
  watch: {
    activeLanguageChanged() {
      let elementsToTranslate = document.querySelectorAll('[data-force-vue-translate=true],[data-translate-code]');
      if (elementsToTranslate.length > 0) {
        for (let elementToTranslate of elementsToTranslate) {
          elementToTranslate.innerHTML = this.translate(elementToTranslate.dataset['translateCode']);
        }
      }
    },
  },
  data() {
    return {
      loading: true
    }
  },
  methods: {
    translate(code) {
      let arg = {
        type: 'translate',
        code: code,
        out: ""
      }

      this.$store.commit(arg);

      return arg.out;
    },
  },
  created() {
    let interval = setInterval(() => {
      if (window.localStorage.getItem('application_data_loaded') === 'true') {
        this.loading = false;
        clearInterval(interval);
      }
    }, 100);
  }
}
</script>

<style lang="scss">
@import "./assets/scss/main";

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>
